import React, {useState, useEffect, useRef} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, CardTitle,CardText, Form, Container, Button, Alert,Modal, Table } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import Select from 'react-select'

import { Link, useHistory } from "react-router-dom"
 import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

import axios from 'axios';
import { Config, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import { WQDATA, WQSAMPLES, SAMPLINGPOINTS, PARAMETERS, COMPANY } from 'helpers/url_helper';

import toastr from "toastr";
import "toastr/build/toastr.min.css";

import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'
import { HRConfig } from 'helpers/backend_helper';
import SPMap from './Maps/SPMap';


    const AddWQData = () => {
        const inputRef = useRef(null);
        const history = useHistory();
        const [modal_line, setmodal_line] = useState(false);
        const [isEdit, setIsEdit] = useState(false)
        const [isLoading, setIsLoading] = useState(false)

        const [samplingPoint, setSamplingPoint] = useState('')
        const [samplingDateTime, setSamplingDateTime] = useState(new Date())
        const [sampleNumber, setSampleNumber] = useState('SA-')
        const [sampleComment, setSampleComment] = useState('')
        const [postedBy, setPostedBy] = useState('')
        const [sampleStatus, setSampleStatus] = useState('')

        const [parameterName, setParameterName] = useState('')
        const [parameter, setParameter] = useState('')
        const [type, setType] = useState('')
        const [standard, setStandard] = useState('')
        const [instrument, setInstrument] = useState('')
        const [units, setUnits] = useState('')
        const [results, setResults] = useState('')

        const [resultsList, setResultsList] = useState([])
        const [previousData, setPreviousData] = useState([])

        const [inputs, setInputs] = useState([]);
        const [isloading, setIsloading] = useState(false);
        const [userError, setUserError] = useState(true);
        const [dataSaved, setDataSaved] = useState(false)
        const [lPNo, setLPNo] = useState('')

        toastr.options = TOAST_OPTIONS;

        const [paramsList, setParamsList] = useState([]);
        const [sPointsList, setSPointsList] = useState([]);
        
        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_line = () => {
            setmodal_line(!modal_line)
            removeBodyCss()
        }
        const handleGetStandard = (c) =>{
            setIsLoading(true)
            axios.get(`${PARAMETERS}?${c}`, Config).then((r)=>{
                setIsLoading(false)
                setType(r.data[0].type)
                setUnits(r.data[0].unit)
                setStandard(r.data[0].standard)
                setInstrument(r.data[0].instrument)
                setParameterName(r.data[0].name)
                inputRef.current.focus();
                inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
            }).catch((e)=>{
                console.log(e)
                toastr.error(e)
                setIsLoading(false)
            })
        }
        const handleAddResult = () =>{
            if(results.length < 1){
                toastr.error('Enter parameter results')
            }else{
                const data = {
                    paramId: parameter,
                    parameterName: parameterName,
                    type: type,
                    units: units,
                    standard: standard,
                    instrument: instrument,
                    results: results
                }
                setResultsList(state =>[...state, data])
                //tog_line()
                setParameter('')
                setParameterName('')
                setType('')
                setStandard('')
                setInstrument('')
                setResults('')
            }
            
        }
        const handleGetData = (p) =>{
            const data = { id  : '', sDate: '', eDate: '', sPoint: p, sStaff: '' }
            axios.post(WQSAMPLES, JSON.stringify(data), Config).then((r)=>{ setPreviousData(r.data) }).catch((e)=>{  console.log(e); });
        }
        const fetchData = () => {
          axios.get(SAMPLINGPOINTS, Config).then((r)=>{ setSPointsList(r.data);  }).catch((e)=>{  console.log(e); });
          axios.get(PARAMETERS, Config).then((r)=>{ setParamsList(r.data);  }).catch((e)=>{  console.log(e); });
          const obj = JSON.parse(localStorage.getItem("authWTUser"))
          setPostedBy(obj.username)
        }
        
        useEffect(() => {
         fetchData();
        },[]);
  

        const handleSubmit = () => {
            const obj = JSON.parse(localStorage.getItem("authWTUser"));
            const sentBy = obj.username;
   
            const data = {
                "sentBy"    : sentBy,
                "pointId"   : samplingPoint,
                "dateTime"  : samplingDateTime.toISOString().slice(0, 19).replace('T', ' '),
                "number"    : sampleNumber,
                "comment"   : sampleComment,
                "results"   : resultsList,
                "action"    : 'add'
            }
          
           if(resultsList.length < 2){
                toastr.error('Please add sampling test results')
            }else if(samplingPoint == ""){
                toastr.error('Please select sampling point')
            }else if(sampleNumber.trim().length < 2){
                toastr.error('Please enter sample number/identity')
            }else{
                axios.post(WQDATA, JSON.stringify(data), Config)
                .then((r)=>{
                    if(r.data.status == '0'){
                        toastr.error(r.data.message); 
                    }else{
                        toastr.success(r.data.message); 
                        setDataSaved(true)
                        history.push('/Water-Sampling')
                    }
                })
                .catch((e)=>{
                    console.log(e);
                });
            }
            
        }
        
        return (
            <>
            <LoadingOverlay
                active={isloading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Add sample data | {COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title={COMPANY} breadcrumbItem="Add sample data" />
                        <div>
                       

                        {(dataSaved == false) ? (
                        <Row>
                        <Col xl={8}>
                        <Card>
                            <CardBody>
                            <CardTitle>Sample </CardTitle>
                                    <Row className='mt-4 mb-4'>
                                    <Col md={6}>
                                        <div className="mb-3">
                                        <label>Sampling Point</label>
                                        <select className="form-select" value={samplingPoint} onChange={(e)=>{setSamplingPoint(e.target.value); handleGetData(e.target.value)}}>
                                        <option value=""> Select</option>
                                        { sPointsList && (sPointsList.length > 0) && (
                                            sPointsList.map((p,k)=>(
                                                <option key={k} value={p.id}>{p.name} - {p.type}</option>
                                            ))
                                        )}
                                            </select>
                                        
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                        <label>Sampling Date and Time</label>
                                                <Flatpickr
                                                    className="form-control"
                                                    options={{
                                                        mode: "single",
                                                        dateFormat: "Y-m-d H:i",
                                                        enableTime: true
                                                    }}
                                                    value={samplingDateTime}
                                                    onChange={(dateTime)=>setSamplingDateTime(dateTime[0] || null)}
                                                    />
                                                
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                        <label>Sample Number</label>
                                                <input  type='text' className="form-control" value={sampleNumber} onChange={(e)=>setSampleNumber(e.target.value)}/>
                                                
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                        <label>Posted By</label>
                                                <input  type='text' className="form-control" value={postedBy} onChange={(e)=>setPostedBy(e.target.value)} disabled={true}/>
                                                
                                        </div>
                                    </Col>
                                    
                                    
                                    </Row>
                                </CardBody>
                            </Card>

                            

                                <Modal isOpen={modal_line} toggle={() => { tog_line(); }}  size="l" centered  backdrop={'static'}  >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ isEdit? `Update Results`:`Add Results` }</h5>
                                    <button type="button"  onClick={() => { setmodal_line(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                   <Row>
                                   <Col lg={6} className="mb-3">
                                        <div className="mb-3">
                                        <label>Parameter</label>
                                        <select className="form-select" value={parameter} onChange={(e)=>{setParameter(e.target.value); handleGetStandard(e.target.value); }}>
                                            <option value=""></option>
                                            {(paramsList || []).map((formRow, key) => (
                                                <option value={formRow.id} key={key} >{formRow.name}</option>
                                            ))}
                                        </select>
                                        
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Type</label>
                                            <input  type='text' className="form-control" disabled={true} defaultValue={type} />    
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Instrument</label>
                                            <input  type='text' className="form-control" disabled={true} defaultValue={instrument} />    
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Standard</label>
                                            <input  type='text' className="form-control" disabled={true} defaultValue={standard} />    
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Results</label>
                                            <input  type='text' className="form-control" ref={inputRef} value={results} onChange={(e)=>setResults(e.target.value)}/>    
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Units</label>
                                            <input  type='text' className="form-control" disabled={true} defaultValue={units} />    
                                        </div>
                                    </Col>
                                    
                                   </Row>
                                  </div>
                                  <div className="modal-footer justify-content-end">
                                  <button type="button" className="btn btn-danger me-2" onClick={()=>tog_line()} >Cancel</button> 
                                    {(isLoading ? 
                                            (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                        : ( <button type="button" className="btn btn-success" onClick={handleAddResult}>Add result...</button> ))
                                    }</div>
                                </Modal>
                                
                            <Card>
                                <CardBody>
                           
                                <CardTitle className="mb-3">
                                Results
                                </CardTitle>
                                
                                <div>
                                {(resultsList.length > 0) ? (
                                            <div className="table-responsive">
                                                <Table className="table table-striped table-sm mb-4">
                                                    <thead>
                                                        <tr>
                                                            <th>Parameter</th>
                                                            <th>Type</th>
                                                            {/*<th>Instrument</th>*/}
                                                            <th>Standard</th>
                                                            <th>Units</th>        
                                                            <th>Results</th>
                                                            
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                      	                {resultsList.map((a,k)=>(
                                                            <tr key={k}>
                                                                <td>{a.parameterName}</td>
                                                                <td>{a.type}</td>
                                                                {/*<td>{a.instrument}</td>*/}
                                                                <td>{a.standard}</td>
                                                                <td>{a.units}</td>
                                                                <td>{a.results}</td>
                                                               
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                                </div>
                                            ):(
                                                <div className="text-center">
                                                    <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h5>No data yet</h5>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                                    </div>
                                                </div>
                                            )}
                                        <Row>
                                            <Col lg={12} className="mb-3">
                                                <div className="mb-3">
                                                <label>Comment</label>
                                                <textarea className="form-control" value={sampleComment} onChange={(e)=>setSampleComment(e.target.value)} />
                                                </div>
                                            </Col>
                                        </Row>
                     
                                        </div>
                                    
                                                <Row className=' mb-4 mt-4 justify-content-center'>
                                                    <Col md={4}>
                                                        <div className="d-grid gap-2">
                                                            <Button
                                                                color="success"
                                                                className="btn btn-rounded"
                                                                onClick={() => { tog_line(); setParameter(''), setInstrument(''); setType(''); setStandard(''); setResults(''); setUnits('') }}
                                                                >
                                                                Add parameter results
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                    <Col md={4}>
                                                        <div className="d-grid gap-2">
                                                            <Button color="primary" type="button" className="btn btn-rounded" onClick={handleSubmit}>
                                                                Save sampling data...
                                                            </Button>
                                                        </div>
                                                    </Col>
                                        
                                                </Row>
                                            </CardBody>
                                        </Card>
                                        <Card>
                                <CardBody>
                           
                                <CardTitle className="mb-3">
                                Previous data
                                </CardTitle>
                                
                                <div>
                                {(previousData.length > 0) ? (
                                            <div className="table-responsive">
                                                <Table className="table table-striped table-sm mb-4">
                                                    <thead>
                                                        <tr>
                                                            
                                                            <th>Date</th>
                                                            <th>Point</th>
                                                            <th style={{ textAlign: 'center' }}>Sample</th>
                                                            <th style={{ textAlign: 'center' }}>Parameters</th>
                                                            <th>Posted by</th>
                                                            
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                      	                {previousData.map((a,k)=>(
                                                            <tr key={k}>
                                                                <td>{a.date}</td>
                                                                <td>{a.point}</td>
                                                                <td style={{ textAlign: 'center' }}>{a.sample}</td>
                                                                <td style={{ textAlign: 'center' }}>{a.sampleData.length}</td>
                                                                <td>{a.postedBy}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                                </div>
                                            ):(
                                                <div className="text-center">
                                                    <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-danger display-4" />
                                                    </div>
                                                    <div>
                                                    <h5>No previous data</h5>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                                    </div>
                                                </div>
                                            )}
                                            </div>
                                </CardBody>
                            </Card>
                                        
                    
                        </Col>
                        <Col lg="4">
                            <Card>
                                <CardBody>
                                <h5 className="card-header bg-transparent border-bottom text-uppercase">LOCATION</h5>
                                
                                 <SPMap/>


                               
                                </CardBody>
                            </Card>
                            </Col>
                        </Row>
                        ):(
                            <Row className="d-flex justify-content-center">
                                <Col lg={8} >
                                <Card outline color="success" className="border">
                                    <CardBody>
                                    <CardTitle className="mb-4 text-white">
                                        
                                    </CardTitle>
                                    <CardText>
                                        
                                    </CardText>
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-check-circle-outline text-success display-4" />
                                        </div>
                                        <div>
                                        <h5>Saved</h5>
                                        <p className="text-muted">
                                                 <strong>WQ Data Saved</strong>
                                        </p>
                                        </div>
                                    </div>
                                    </CardBody>
                                </Card>
                                </Col>
                            </Row>
                        )}
                        </div>


                    </Container>
                    
                       
                    
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default AddWQData;